var map = {
	"./bulk-custom-oem-package-1.jpg": 154,
	"./kids-polo-smart-1.jpg": 831,
	"./kids-polo-smart-2.jpg": 512,
	"./kids-tshirt-boys-graphic-1.jpg": 372,
	"./kids-tshirt-boys-graphic-2.jpg": 947,
	"./kids-tshirt-girls-pastel-1.jpg": 31,
	"./mens-polo-classic-1.jpg": 712,
	"./mens-trackpants-slimfit-1.jpg": 673,
	"./mens-trackpants-slimfit-2.jpg": 918,
	"./mens-tracksuit-performance-1.jpg": 416,
	"./mens-tracksuit-performance-2.jpg": 412,
	"./mens-tracksuit-performance-3.jpg": 650,
	"./mens-tshirt-basic-round-1.jpg": 897,
	"./mens-tshirt-basic-round-2.jpg": 478,
	"./mens-tshirt-dryfit-vneck-1.jpg": 78,
	"./women-coord-lounge-set-1.jpg": 337,
	"./women-feeding-kurti-zipfront-1.jpg": 47,
	"./women-feeding-kurti-zipfront-2.jpg": 331,
	"./women-innerwear-cotton-brief-pack3-1.jpg": 241,
	"./women-maternity-top-layered-1.jpg": 886
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 815;